import { configureStore } from '@reduxjs/toolkit';

import { appStateSlice } from './appState/appState';
import { careerPathSlice } from './careerPath/careerPath';
import { collegeSlice } from './college/college';
import { collegeApi } from './college/college.api';
import { contentCategorySlice } from './contentCategory/contentCategory';
import { contentCompetencySlice } from './contentCompetency/contentCompetency';
import { contentNuggetSlice } from './contentNugget/contentNugget';
import { dataDictionarySlice } from './dataDictionary/dataDictionary';
import { employerSlice } from './employer/employer';
import { employerApi } from './employer/employer.api';
import { lifeReadinessApi } from './lifeReadiness/lifeReadiness.api';
import { sessionStateReducer } from './lubavSessionState/lubavSessionState';
import { makeItPersonalSlice } from './makeItPersonal/makeItPersonal';
import { makeItPersonalApi } from './makeItPersonal/makeItPersonal.api';
import { onboardingApi } from './onboarding/onboarding.api';
import { profileApi } from './profile/profile';
import { searchSlice } from './search/search';
import { surveyStateSlice } from './survey/survey';
import { toolsApi } from './tools/tools.api';
import { tourSlice } from './tour/tour';
import { trackAssessmentApi } from './trackAssessment/trackAssessment.api';
import { userSlice } from './user/user';
import { userApi } from './user/user.api';
import { userDocumentsApi } from './user/user.documents.api';
import { userResponseSetSlice } from './userResponse/userResponse';

export const store = configureStore({
  reducer: {
    user: userSlice.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [onboardingApi.reducerPath]: onboardingApi.reducer,
    [lifeReadinessApi.reducerPath]: lifeReadinessApi.reducer,
    [profileApi.reducerPath]: profileApi.reducer,
    [makeItPersonalApi.reducerPath]: makeItPersonalApi.reducer,
    [toolsApi.reducerPath]: toolsApi.reducer,
    [employerApi.reducerPath]: employerApi.reducer,
    [collegeApi.reducerPath]: collegeApi.reducer,
    [trackAssessmentApi.reducerPath]: trackAssessmentApi.reducer,
    [userDocumentsApi.reducerPath]: userDocumentsApi.reducer,

    // COLLEGE
    college: collegeSlice.reducer,

    // EMPLOYER
    employer: employerSlice.reducer,

    // MAKE IT PERSONAL
    makeItPersonal: makeItPersonalSlice.reducer,

    // BLUEPRINT
    userResponseSet: userResponseSetSlice.reducer,
    survey: surveyStateSlice.reducer,
    careerPath: careerPathSlice.reducer,
    dataDictionary: dataDictionarySlice.reducer,
    tour: tourSlice.reducer,

    // PROSPER
    contentCategory: contentCategorySlice.reducer,
    contentCompetency: contentCompetencySlice.reducer,
    contentNugget: contentNuggetSlice.reducer,
    search: searchSlice.reducer,

    // LUBAV SESSIONS
    sessionState: sessionStateReducer,

    // APP STATE
    appState: appStateSlice.reducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      userApi.middleware,
      onboardingApi.middleware,
      lifeReadinessApi.middleware,
      profileApi.middleware,
      makeItPersonalApi.middleware,
      toolsApi.middleware,
      employerApi.middleware,
      collegeApi.middleware,
      trackAssessmentApi.middleware,

      userDocumentsApi.middleware,
      // additionally, should it be required please add it to the logoutThunk
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
